import action from '@/store/modules/action'
import alert from '@/store/modules/alert'
import api from '@/store/modules/api'
import apiProduct from '@/store/modules/apiProduct'
import apiToken from '@/store/modules/apiToken'
import campaign from '@/store/modules/campaign'
import city from '@/store/modules/city'
import destination from '@/store/modules/destination'
import device from '@/store/modules/device'
import document from '@/store/modules/document'
import locked from '@/store/modules/locked'
import notification from '@/store/modules/notification'
import operator from '@/store/modules/operator'
import payment from '@/store/modules/payment'
import paymentStatus from '@/store/modules/paymentStatus'
import payReason from '@/store/modules/payReason'
import proxiMargin from '@/store/modules/proxiMargin'
import recovery from '@/store/modules/recovery'
import recType from '@/store/modules/recType'
import reductCode from '@/store/modules/reductCode'
import reductCodeUser from '@/store/modules/reductCodeUser'
import referral from '@/store/modules/referral'
import roadPayment from '@/store/modules/roadPayment'
import role from '@/store/modules/role'
import search from '@/store/modules/search'
import setting from '@/store/modules/setting'
import status from '@/store/modules/status'
import statusRec from '@/store/modules/statusRec'
import statusRecovery from '@/store/modules/statusRecovery'
import statusWithdrawal from '@/store/modules/statusWithdrawal'
import upload from '@/store/modules/upload'
import userRoad from '@/store/modules/userRoad'
import withdraw from '@/store/modules/withdraw'
import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import car from './modules/car'
import direction from './modules/direction'
import road from './modules/road'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    user,
    road,
    direction,
    car,
    destination,
    alert,
    device,
    proxiMargin,
    userRoad,
    city,
    payment,
    document,
    search,
    setting,
    roadPayment,
    operator,
    upload,
    api,
    apiProduct,
    apiToken,
    paymentStatus,
    recovery,
    statusRec,
    statusRecovery,
    reductCode,
    status,
    reductCodeUser,
    notification,
    locked,
    recType,
    payReason,
    role,
    campaign,
    action,
    referral,
    withdraw,
    statusWithdrawal,
  },
})
